<script>
import { Vue, Component, Prop } from 'vue-property-decorator'
import { State } from 'vuex-class'

@Component
class BenefitsBase extends Vue {
  @Prop({ type: String, required: true }) game
  @State('country') currentCountry

  onTrackHover (event) {
    this.$analytics.trackHoverToPromotionBanner({
      screenId: this.$route.path, benefitId: `${this.game}_${this.currentCountry}_${event.currentTarget.id}`
    })
  }
}

export default BenefitsBase
</script>
